import { LoginCallback } from '@okta/okta-react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function OktaLoginCallback() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F6F6F6',
        p: 3,
      }}
    >
      <Box 
        sx={{ 
          width: '100%', 
          maxWidth: 400, 
          bgcolor: '#fff', 
          borderRadius: 1, 
          p: 4, 
          textAlign: 'center',
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        }}
      >
        <Typography variant="h6" sx={{ marginBottom: 2, color: 'text.primary' }}>
          Completing sign in...
        </Typography>
        <CircularProgress size={40} sx={{ color: 'primary.main' }} />
        <LoginCallback />
      </Box>
    </Box>
  );
}
